<template>
  <div class="app-activation-privilege-terms">
    <div class="info-box" v-for="term in brandConsents.consents" :key="term.text">
      <span v-html="term.text"></span>
    </div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import transaction from '@/mixins/transaction'

export default {
  name: 'ShowPrivilegeTerms',
  data() {
    return {
      brandConsents: {
        consents: [
          {
            text: ''
          }
        ]
      },
      brand: ''
    }
  },
  mixins: [transaction('activation')],
  props: {
    filterKeys: {
      type: String,
      default: 'privilege_terms'
    }
  },
  apollo: {
    brandConsents: function() {
      return wrapQuery(
        gql`
          query activation($brand: String!, $filterKeys: [String!]) {
            brandConsents(brand: $brand, filterKeys: $filterKeys) {
              consents {
                text
              }
            }
          }
        `,
        this,
        'brandConsents',
        {
          brand: this.$store.getters.brand,
          filterKeys: this.filterKeys
        }
      )
    }
  }
}
</script>
